import React from "react";
import {Helmet} from "react-helmet";

export default function Mcluhan() {
    return (
        <div>
            <Helmet>
                <title>[文]品牌时代 The Brand Age</title>
            </Helmet>
            <h6 className="App-essay-title">[文]品牌时代</h6>
            <p className="App-essay-article">
                <br/>
                <b>二〇二六 三月</b>
                <br/><br/>
                <i style={{color: "grey"}}><b>
                    美西时间3月5日早上（国内时间3月6号），保罗 · 格雷厄姆（后简称P.G.）在X上分享了自己的最新文章。和往常一样，翻译尽量保留PG的行文风格和特殊用词，并减少我的个人偏好。
                    <br/><br/>
                    PG用了大篇幅描述20世纪70年代，老欧洲垄断性的瑞士制表行业，面临日本同行追赶、汇率打击、石英表冲击时所做的选择。他似乎也在描述另一场竞赛和另一场危机。他在文末的态度也值得玩味。
                    <br/><br/>
                    PG的文章不需要写解读。他的文章足够意味深长，值得直接完整地阅读他的文字。请读者尽可能地相信自己的第一手判断。
                    <br/><br/>
                    小趣事：
                    <br/>
                    - 网友留言：这是互联网上唯一一个地方，作者使用了长破折号 —— 会验证这是真人写的（而不是AI）。<br/>
                    - PG回复：你觉得它从哪儿学的？
                    <br/><br/>
                    前言够长了。Enjoy-
                    <br/><br/>
                </b>
                </i>
                ------<br/><br/>

                <b>作者：</b>Paul Graham<br/>
                <b>原文：</b>https://paulgraham.com/brandage.html<br/>
                <b>翻译：</b>GPT 5.2 (~20,000 tokens)<br/>
                <b>校对：</b>Kun Cheng<br/><br/><br/>
                <h6><b>品牌时代 The Brand Age</b></h6>
                <br/>
                <b>2026 年 3 月</b>
                <br/><br/>
                20 世纪 70 年代初，瑞士制表业遭遇了灾难。现在人们把它称为“石英危机”（Quartz Crisis），但事实上，那是一组几乎同时发生的、彼此叠加的三场独立灾难。
                <br/><br/>
                第一场是来自日本的竞争。整个 60 年代，瑞士人一直通过后视镜观察日本同行，他们以惊人的速度在进步。即便如此，瑞士人仍在 1968 年被震惊：在日内瓦天文台的竞赛测试中，日本厂商包揽了机械手表的所有前列名次。
                <br/><br/>
                瑞士人知道接下来会发生什么。多年来，日本人一直能造出更便宜的手表。现在，他们也能造出更好的了。
                <br/><br/>
                雪上加霜的是，瑞士表还即将变得更贵。布雷顿森林体系自 1945 年起固定了世界多数货币的汇率，将瑞士法郎人为地压在 0.228 美元的低位。1973 年布雷顿森林体系解体后，法郎迅速升值；到 1978 年已升至 0.625
                <br/><br/>
                美元，这意味着美国人购买瑞士表的成本变成了原来的 2.7 倍。[1]
                <br/><br/>
                即使没有石英机芯，外部竞争加上保护性汇率的消失，也足以重创瑞士制表业。但石英机芯是最后一击：他们一直试图赢下的那场比赛，突然变得毫无意义。曾经昂贵的东西 —— 知道准确时间 —— 如今成了大宗商品（commodity）。
                <br/><br/>
                从 70 年代初到 80 年代初，瑞士表的销量（以手表只数计）下跌了将近三分之二。大多数瑞士表厂破产或濒临破产而被收购。但并非全部的瑞士表厂。少量品牌以独立公司的形态存活下来，而它们的生存方式，是把自己从“精密仪器制造商”转型为“奢侈品牌”。
                <br/><br/>
                在这个过程中，机械表的本质也被改写。最昂贵的手表向来不便宜，但它们“为什么贵”、以及买家“买到了什么”，已经彻底改变。1960 年，昂贵手表之所以昂贵，是因为它们的制造成本真的很高；买家买到的回报，是在同等尺寸下，能做出来的最精确的计时装置。如今它们昂贵，是因为品牌在广告上投入巨大，并且耍手段限制供应量；买家得到的回报，是一个昂贵的身份象征。
                <br/><br/>
                不过这门生意确实赚钱。瑞士制表业如今从“卖品牌”中赚到的钱，可能比他们继续“卖工程”还要多。事实上，看看按销售收入统计的瑞士表销售图，你会得到与按销售数量统计完全不同的故事：收入并没有断崖式下跌，只是暂时趋于平缓；随后在 80 年代末像火箭一样起飞 —— 幸存的制表商最终接受了自己的新命运。
                <br/><br/>
                制表商花了大约 20 年才摸清这套全新的游戏规则。观察他们的摸索过程很有意思，因为它们转型之彻底，使它成为我们这个时代最强大的力量之一 —— 品牌（Brand） —— 完美的研究案例。
                <br/><br/>
                当产品之间实质性的差异消失后，剩下的就是品牌。但让产品之间的实质性差异消失，恰恰是技术的自然趋势。所以瑞士制表业发生的事并不只是一个有趣的孤例，而是极其贴近我们这个时代的故事。
                <br/><br/><br/><br/>

                积家（Jaeger-LeCoultre）官网称其某个现行的系列是“灵感源自制表黄金时代的经典设计”。这句话在暗示一件当今的制表人都心知肚明、却很少如此直白说出口的事：不管我们现在处于什么时代，都不再是黄金时代了。
                <br/><br/>
                制表的黄金时代是 1945 到 1970 年 —— 从行业走出战争混乱、瑞士占据顶峰开始，直到 60 年代末起那场三重浩劫降临为止。黄金时代里，制表商的两样最高追求是：薄与准。而事实上，这几乎就是制表的核心取舍：手表是随身携带用来报时的东西，所以改进它有两条根本路径：让它更便携，和让它报时更精准。
                <br/><br/>
                显然准确很重要，但在黄金时代，“薄”甚至更重要。哪怕在怀表时代，最好的制表师也会尽可能把表做薄。廉价而厚重的怀表会被嘲笑为“萝卜”（turnips）。当一战期间男表从口袋走上手腕时，“薄”的紧迫性进一步上升。由于“做薄”比“做准”更难实现，黄金时代里，往往正是薄这项特质区分了更昂贵的手表。
                <br/><br/>
                还有一类追求在某些时代也很重要：就是常规报时之外提供别的功能，比如显示月相，或用声音报时。行业里把这类功能称为“复杂功能”（complications）。它们在 19 世纪很流行，如今也再次流行，但在黄金时代，除了一个实用的复杂功能（显示日期），它们基本都只是配角。在黄金时代，正如所有黄金时代，顶级制表商只专注于实质性的取舍，并且，也如所有黄金时代，他们做得极其出色。黄金时代最好的手表有一种安静的完美，此后从未被超越。而且出于我接下来要解释的原因，恐怕也再也不会被超越。
                <br/><br/>
                黄金时代最负盛名的三大品牌是所谓的“神圣三位一体”（holy trinity）：百达翡丽（Patek Philippe）、江诗丹顿（Vacheron Constantin）和爱彼（Audemars Piguet）。它们的声望大体上名副其实，都源自卓越的工艺质量。到 60 年代，它们靠两条腿站立：声望与性能。接下来二十年里它们学到的是：必须把全部重量压在第一条腿上，因为它们已经不可能再在制表史上那两项传统目标上取胜。石英机芯不仅比任何机械机芯都更准，而且还更薄。
                <br/><br/>
                “神圣三位一体”至少还能靠另一条腿，声望，支撑。多数其他知名瑞士表厂卖的只有性能。这些公司没有一家能原封不动地存活下来。
                <br/><br/>
                欧米茄（Omega）展示了什么叫“不该怎么做”。欧米茄是瑞士制表商中的技术宅。他们造出了极其精准的手表，但对“成为奢侈品牌”这件事，充其量是摇摆不定、甚至是抵触。当日本人在精准机芯上追上瑞士后，欧米茄用欧米茄式的方式回应：把机芯做得更准。他们在 1968 年推出一种新机芯，振频提高了 45%。理论上这应当更准确，但新机芯脆弱得惊人，反而摧毁了他们可靠性的声誉。他们甚至试图做更好的石英机芯，但那条路尽头只有向下竞赛。到 1981 年他们已经资不抵债，被债权人接管。
                <br/><br/>
                百达翡丽采取了相反策略：当欧米茄在重做机芯时，百达翡丽在重做表壳。或者更准确地说，是在“开始设计表壳”，因为在那之前他们并没有这么做过。
                <br/><br/>
                这里或许该提一点，当年的瑞士制表业是多么奇特的一个怪物。那是一种今天很难想象的资本主义形态，甚至在当时也只有在瑞士这种国家才能如此运转：由法规锁定位置的一张小而专、彼此分工的公司网络。我们为方便称作“表厂”的那些公司，只是这张网络里面向消费者的前台而已。“神圣三位一体”既不设计自家表壳，甚至大多数时候连自家机芯也不是自己设计。
                <br/><br/>
                1968 年（又是这一年），百达翡丽推出一款新表，改变了表壳设计的重心。这一次他们把自己的设计拿给制壳商，说：“就按这个给我们做。”结果是一款令人惊艳的新型号，名为 Golden Ellipse（“金椭圆”）。名字有点令人困惑，因为它并不是椭圆。这种表壳更像 UI 设计师所谓的“圆角矩形”（round rect）：一个四角圆润的矩形。这个系列相当成功，但它的意义不止于此：它成了未来的范式。[2]
                <br/><br/>
                仅仅设计一个辨识度很高的表壳，怎么会如此重要？因为它让整只手表变成了品牌表达。
                <br/><br/>
                从“想靠手表的品牌给别人留下印象”的角度看，黄金时代最好的手表有个麻烦：没人看得出你戴的是什么牌子。除非距离近到几英寸以内，否则顶级制表商的表看起来都差不多。极简主义就是这样：最终的答案往往只有一个。再加上黄金时代的手表按今天的标准看，尺寸很小。制表商花了几个世纪把表做小，到 1960 年已非常擅长此道。所以顶级品牌之间唯一的差别，就是表盘上印的名字，但表盘太小，这些字也极小。“圣三位一体”黄金时代手表上厂牌字样的高度只有 0.5 到 0.75 毫米。通过掌控表壳，百达翡丽把“品牌”的面积从 8 平方毫米扩大到了 800。
                <br/><br/>
                为什么他们在低语了一个世纪后，突然决定让品牌“喊出来”？因为他们知道性能上赢不了日本人。从此以后，他们必须更依赖品牌。
                <br/><br/>
                这么做是有代价的，这在“表壳即品牌”（case-as-brand）的早期例子里就能看到。“圆角矩形”（Golden Ellipse）并不难看。70 年代设计师把一切都做成圆角矩形时，它们可能看起来更酷。但“圆角矩形”并不是表壳设计的进化式前进。手表并没有集体变成圆角矩形。制表商早就发现，对一个旋转时描绘圆形轨迹的物体来说，表壳的最优形状是什么。
                <br/><br/>
                他们也早就发现表冠 —— 表侧用来上发条的那个小旋钮 —— 的最优形状。但为了强调 Ellipse 的独特轮廓，百达翡丽把表冠做得太小，结果就是上发条难得让人分心。[3]
                <br/><br/>
                所以即便在这个早期例子里，我们也能看到品牌与设计关系中的关键点：品牌并不仅仅与好设计“相互独立”，而是与之对立。品牌按定义必须“独特”；而好设计就像数学或科学，它追求“正确答案”，而正确答案往往趋同。
                <br/><br/>
                品牌是离心的（centrifugal）；设计是向心的（centripetal）。
                <br/><br/>
                当然这里也有一定弹性。设计不像数学那样有清晰到极致的唯一正确答案，尤其设计是面向人类观众的。所以出于诚实的动机，去设计一些独特之处，未必就是坏设计。但你无法回避品牌与设计的根本冲突，就像无法回避地心引力一样。
                <br/><br/>
                实际上，品牌与设计的冲突如此根本，以至于它远远超出我们称之为“设计”的领域。宗教里也能看到：如果你想让某个宗教的信徒拥有能把他们与他人区分开的习俗，你就不能让他们做方便或合理的事 —— 否则别人也会这么做。想要区分，就必须让他们做不方便、不合理的事。
                <br/><br/>
                你要让设计“与众不同”也是同理。如果你选择了好选项，别人也会选择它。
                <br/><br/>
                品牌与好设计只有两种方式能兼容。第一种是“可能性的空间极其巨大”，例如绘画。列昂纳多·达·芬奇可以把画画到最好，同时又画出极其“达·芬奇式”的风格。如果当时有一百万个像贝利尼（Bellini）和达·芬奇一样好的画家，这就难多了；但因为当时大概只有十来个这样的人物，他们彼此就不怎么撞车。[4]
                <br/><br/>
                第二种品牌和设计能结合的情况是，可能性的空间仍未被探索。如果你第一个抵达新领地，你既能找到正确答案，又能暂时把它当作你的独门标识。但这只在最初有效；如果你真的找到了正确答案，其他人的设计也终会不可避免地向你收敛，你的品牌优势也会随时间流失。
                <br/><br/>
                由于手表设计的空间既不算尚未探索，也不算可能性巨大，所以品牌化只能以牺牲好设计作为代价。事实上，如果要用一句话概括当下的制表时代，这句就很贴切。
                <br/><br/>
                百达翡丽当时并不确定“让手表明显品牌化”是否可行；这甚至不是他们当时唯一的策略。他们是在摸索。但至少从营收看，这是确实奏效的策略。
                <br/><br/>
                要让它奏效，顾客也得“配合”。百达翡丽知道，不是所有顾客都为性能买单 —— 不全是为了准和薄。他们知道，至少有一些顾客买是因为它贵。但到底有多少人如此、又能把他们推多远，这点并不清楚。
                <br/><br/>
                为了鼓励这种倾向，百达翡丽做了一件“神圣三位一体”此前很少做的事：品牌广告。而广告内容谈的是它的表有多贵。百达翡丽 1968 年的一则广告解释道，你“为什么明智地应该投资相当于半个月收入”买一只 Ellipse。“像每一只百达翡丽一样，”广告接着说，“这款超薄表是全手工打造。由于百达翡丽是最昂贵的手表之一，产量被严格限制：每天只有 43 只通过检验，交付给世界各地的著名珠宝商。”[5]
                <br/><br/>
                你能看出这是早期广告，因为它仍提到了“薄”。但完全没提到“准”。百达翡丽大概认为那场战役已经输了。
                <br/><br/>
                下一步由爱彼（Audemars Piguet）迈出。1970 年他们委托著名设计师杰罗·尊达（Gérald Genta）为其设计一款标志性手表，并大胆使用钢材。成果是 1972 年发布的名款 Royal Oak（皇家橡树）。爱彼的广告（他们也开始做品牌广告）更戏剧化地强调高价。“以黄金的价格推出精钢，”其中一则写道。“你正看着的是全世界最昂贵的不锈钢手表 —— 爱彼‘皇家橡树’。它之所以比黄金更珍贵，是因为打造它所投入的时间，出自一个日渐消失的制表大师群体。”广告底部还把传统话术倒过来说，称其手表“价格从 35,000 美元起，向下覆盖”。
                <br/><br/>
                皇家橡树也把“用于品牌表达的表面面积”又推进了一步。“金椭圆”（Golden Ellipse） 让表盘成为品牌表达，但仍用普通表带或表链；皇家橡树则把表盘与金属表链一体化，设计语言延伸至整圈手腕。当它说“全世界最昂贵的不锈钢手表”时，是用每一平方毫米在说。
                <br/><br/>
                顾客会买账吗？最初结果算是温和鼓舞。“神圣三位一体”的销量没有起飞，但也没有归零。至少有些人对新信息有些反应。也许只要继续做下去，人数会变多。
                <br/><br/>
                于是他们继续。受皇家橡树成功鼓舞，百达翡丽在 1974 年委托设计师尊达（Gérald Genta）为他们设计一款类似的表。皇家橡树的设计灵感来自船舷窗，那么这款新表的灵感也来自……船舷窗。它叫 Nautilus（鹦鹉螺），1976 年在巴塞尔钟表展推出。
                <br/><br/>
                在鹦鹉螺身上，我们真正看到品牌与设计的不相容。它巨大无比。黄金时代巅峰期最昂贵的男表通常直径 32 或 33 毫米；鹦鹉螺有42 毫米。不仅巨大，表盘两侧还有多余的突起，像一对耳朵。但你在房间的另一头就能认出来。
                <br/><br/>
                在百达翡丽现今所有手表中，鹦鹉螺最受追捧。它与当代买家的偏好完全对齐——本质上就是尽可能响亮地表达品牌。但在 1976 年，它超前了，在那一年，它还是“有一点太过”。
                <br/><br/>
                最终真正扭转百达翡丽命运的，是另一款标志性设计：hobnail calatrava（巴黎钉纹卡拉卓华）。之所以叫 hobnail（钉饰/铆钉纹），是因为表壳装饰了细小的金字塔形突起。这就足以显得独特。但除了钉纹之外，它基本就是黄金时代的正装表。
                <br/><br/>
                巴黎钉纹卡拉卓华据说出自百达翡丽的广告代理公司负责人 René Bittel 的主意。这并非新设计。多年来许多表厂都用过钉纹装饰，百达翡丽自 1968 年起就有带钉纹的型号。但 1984 年，Bittel 对百达翡丽总裁 Philippe Stern 的意思大概是：把它做成你的标准设计，我会做一套广告营销，让人们在脑中把它与品牌绑定。[6]
                <br/><br/>
                效果好得惊人。对应型号 3919 后来被称为“银行家之表”，因为它在 80、90 年代的纽约投行人士中极其流行。到这一步之前，百达翡丽还在押注做石英表，并在广告里防御性地辩称“把石英表装进豪华表壳里”也几乎同样费力。但投行人士买的是“纯机械叙事”。他们甚至不需要自动上链；3919 是手动上链。没关系。百达翡丽不再谈石英机芯。而它的销售额自 70 年代初长期横盘后，到 1987 年已进入清晰上升通道，并延续至今。
                <br/><br/>
                很难说关键因素究竟是 Bittel 的广告技巧，还是受众恰逢其时；但作为认识这些投行人士的人，我更倾向于后者。这群人正是“雅皮士”（yuppy）一词的来源，以奢侈生活闻名。如果有谁会率先采用一种新的炫富方式，那就是他们。反之若 Bittel 早十年发出同样信息，可能根本没人接收。
                <br/><br/>
                无论原因是什么，80 年代后半段确实发生了某种变化，因为所有数据都从那时起开始回升。直到大约 1985 年，人们仍不清楚机械表的未来会怎样；到 1990 年就清楚了。到 1990 年，“用昂贵、强品牌、显眼的机械表作为身份象征”的习惯已经牢固确立。[7]
                <br/><br/>
                过时技术通常不会被当作炫富方式而重新流行。机械表为何例外？因为腕表恰好是这件事的完美载体：哪里比手腕，一个人人可见的地方更合适？更关键的是，用什么东西更合适？你可以戴钻戒或金链子，但对投资银行家来说那在社交上会显得可疑，他们或许粗野，但不是黑手党。相比之下，金表再“正当”不过。公司的董事长还在戴他妻子 20 年前送的那只，那时石英表甚至还没出现。如果“炫富压力的上升”会在任何地方冒出来，那就是手腕这块表。[8]
                <br/><br/>
                至少对男性而言如此。女性从来没有真正接受“戴机械表”这个观念。多数富裕女性乐于戴一只石英机芯的卡地亚 Tank。为什么会不同？部分原因与“购买蒸汽机的人多为男性”相同；但主要原因是，如今昂贵机械表实际上成了男性的“事实上的珠宝”（de facto jewelry），而女性不需要“事实上的珠宝”，因为她们可以直接戴真正的珠宝。
                <br/><br/>
                不过关键在于：机械表必须“足够准确”。一只新的 3919 每天最多只会误差 5 秒。这远不如石英。哪怕最便宜的大众石英表也能做到每天误差 0.5 秒，最好的可达一年误差 3 秒。但在现实中你并不需要那种精度。如果机械表只能做到每天误差一分钟，它们就不可能从“计时工具”跃迁为“财富展示”。一只总显示错误时间的表会显得明显不够奢侈。但每天 5 秒已足够接近。[9]
                <br/><br/>
                这揭示了品牌与质量关系中的重要一点：当产品从“因性能而买”转为“因品牌而买”时，质量并不会不重要，但它的重要性改变了形态。质量变成一道门槛。质量不再需要好到足以卖动产品（品牌负责卖）；但它必须好到足以维护品牌声誉。品牌不能“出戏”。
                <br/><br/>
                对制表商来说，雅皮士恰好及时出现拯救了他们。或者说未必是幸运。因为雅皮士所代表的市场演化在之后愈演愈烈，制表商也被迫被拖着走：如果他们不为香港和迪拜的买家制造巨大而闪耀的表，总会有人去做。所以他们如今就成了在做这件事的人。最初那些相对克制的“品牌与设计冲突”的例子，如今已经演变成对设计的全面战争。
                <br/><br/>
                机械表的当今时代还没有一个正式名字。但如果需要一个，那再明显不过：品牌时代。黄金时代是 1945 到 1970；随后是 1970 到 1985 的石英危机；自 1985 以来，我们进入了品牌时代。
                <br/><br/><br/><br/>

                这不会是唯一的品牌时代。事实上，这甚至不是第一个：自 20 世纪 30 年代巴尔（Barr）艺术体系确立以来，精品艺术就进入了自己的品牌时代。既然未来很可能还会见到更多类似现象，我们值得花点时间看看“品牌时代”是什么样。
                <br/><br/>
                与黄金时代相比，如今有何不同？最佳回答方式或许是：想象我们用时光机把黄金时代的人带到今天，他会注意到什么。
                <br/><br/>
                他走过一条高端商业街时首先会注意到：黄金时代那些著名表厂看起来比以往更兴旺。不仅都还在，而且多数有了自营专卖店，不再像当年那样依赖珠宝商代售。
                <br/><br/>
                但这其实是一种幻觉。70、80 年代以独立公司身份熬过黑暗期的制表商只有三家：百达翡丽、爱彼和劳力士。其余的都归属于六大控股集团；当人们意识到机械表将作为男性奢侈配饰拥有“第二次生命”，这些集团又把它们重新充气复活。它们不再像独立公司，更像被并入底特律三大汽车公司的品牌：用于让母公司覆盖不同市场分层。因此，例如浪琴如今不再与欧米茄竞争，因为同时拥有它们的集团把浪琴划入了更低的市场层级。[10]
                <br/><br/>
                江诗丹顿的专卖店为什么看起来和万国（IWC）、积家（Jaeger-LeCoultre）甚至万宝龙、卡地亚的店都那么像？原因是它们属于同一家公司。服装品牌亦然：你走过城市最繁华的购物区，看似有许多不同品牌的店铺，背后其实由少数财团拥有。这也是这些街区常显得如此“无菌”的原因之一；就像同一个开发商建成的郊区一样，它们缺乏一种自然的多样性。
                <br/><br/>
                当我们的时间旅行者往这些店的橱窗里看，他首先会注意到：手表怎么都这么大。这会让他惊讶，因为在黄金时代，乃至此前所有世纪，“大”意味着“便宜”。黄金时代的一只昂贵男表可能直径 33 毫米、厚 8 毫米；如今昂贵的手表往往直径 42 毫米、厚 10 毫米——体积超过两倍。我们这位访客会震惊：在显然很奢华的店橱窗里，竟摆着看起来像廉价表的东西。[11]
                <br/><br/>
                我们知道这如何发生：当手表从“报时”变成“报品牌”，为了更擅长报品牌，它们就变大了。不止尺寸，形状也变了。这是时间旅行者会注意到的另一点：随着品牌的离心趋势展开，各种奇怪的表壳形状与尴尬的突起层出不穷。他会疑惑：那些沛纳海（Panerai）表冠上的巨大护桥是怎么回事？人们究竟用这些表做什么，才需要如此保护表冠？而且为什么表冠护桥上还刻着“注册商标”的字样？对我们来说这显而易见，但请想象对一个来自“形式追随功能”（form follows function）的黄金时代的人而言，这会多么困惑。[12]
                <br/><br/>
                当他困惑地看着这堆笨重手表时，还会发现另一个模式：其中相当一部分看起来像某个他早已熟悉的“笨重手表品牌”。
                <br/><br/>
                我此前没怎么谈劳力士，因为劳力士并不需要为适应新时代做太多改变。在黄金时代，它就已经一只脚踏入了品牌时代。早期劳力士确实投入很大精力提升手表性能，但他们在“50 年代末停止参加日内瓦和纳沙泰尔的竞赛”，并从大约 1960 年起“基本放弃对机械制表的研究”。[13]
                <br/><br/>
                原因并不是变懒，而是他们发现：把手表作为身份象征来营销，能让销量增长得更快。于是这成为他们 60 年代的重点。十年后石英危机来临时，他们的客户已自我筛选为：不太在乎机芯里是什么，只要看起来就是劳力士。
                <br/><br/>
                而在“可识别性”这件事上，他们领先其他制表商太多。早在 40 年代，他们就拥有我们在 70、80 年代看到百达翡丽与爱彼努力打造的东西：一种一眼就能宣告品牌的表壳。劳力士的外观似乎是有机演化出来的，但一旦形成，他们就意识到其重要性，甚至将其作为卖点之一。60 年代一则劳力士广告写道：“你可以从会议桌的另一端认出它的经典造型，它是由一整块纯金雕刻而成。”
                <br/><br/>
                事实上劳力士在两个维度上都超前：表壳不仅易识别，而且按黄金时代标准也更大。不过这并非营销聪明的结果，而是创始人汉斯·威尔斯多夫（Hans Wilsdorf）对防水表的痴迷带来的副产品。
                <br/><br/>
                正如其名，劳力士 Oyster（蚝式）的存在理由就是防水。蚝式这类表被设计得像吉普车一样坚固。在黄金时代，手表设计有两极：一端是工具表，厚、硬朗，通常是钢；另一端是正装表，薄、优雅，通常是金。但劳力士模糊了这条界线：他们做厚而硬朗的表时，也会用金而不只用钢。结果是一种“奢华吉普”。如果这个短语没有立刻在你脑中响起，停一下想想，因为那正是如今所有人都在开的车：SUV 就是奢华吉普。手表发生的事与汽车发生的事是同一件事。事实上，如果我们的时间旅行者转头看到一辆保时捷卡宴驶过，并意识到那是什么 —— 一台巨大的、伪越野、意在唤起保时捷 911 记忆的车 —— 他可能会比看到那些手表更震惊。[14]
                <br/><br/>
                如果他走进百达翡丽专卖店，真想买一只鹦鹉螺，他将遭遇最大的震撼：他们不会卖给他。因为在百达翡丽，他会遇到品牌时代最极端的现象：人为稀缺。你不能“直接买”一只鹦鹉螺。你必须先花多年通过购买多层级的其他型号来证明忠诚，然后再在等候名单上排上多年。[15]
                <br/><br/>
                显然，这种策略能卖出更多手表。但它也通过让稀缺款远离二级市场来支撑零售价。使用人为稀缺驱动销量的公司不能允许太多稀缺款流入二级市场，否则它们就不再稀缺。理想状态就是手表版的“碳封存”：买家把表戴到去世为止。
                <br/><br/>
                为了把市场推向这一理想，百达翡丽从交易两端挤压。他们通过让通往稀缺款的路径在时间与金钱上都极其昂贵 —— 极其不方便、不合理 —— 只剩下真正的粉丝才能忍受得了。低级别款在二级市场往往低于公价，因为百达翡丽不限制其供给；因此潜在倒卖者必须先做多年“亏钱购买”，才可能拿到能盈利倒卖的东西。尽管如此，似乎仍有人能钻过系统，所以百达翡丽的反制不止于此：他们密切监控二级市场销售，看是谁在卖他们的表。拍卖上架通常包含序列号，易于追踪；必要时他们会在二级市场回购自家手表以获得序列号并追查泄漏源。一年要买回几百只。抓到不想让倒卖的人时，他们不只拉黑该客户；如果某个零售商的客户造成过多“漏洞”，他们会切断整个零售商的供货，这自然让零售商也得积极协助他们监管买家。
                <br/><br/>
                当然，二级市场永远会有一些漏洞。即使最忠诚的客户也会以一定比例去世。事实上，让二级市场继续存在对百达翡丽至关重要，因为它是他们获取最核心信息的最宝贵渠道之一：顶级款的供给该以多快速度增加。稀缺性会驱动其他所有款的购买，所以进入二级市场的顶级款应始终高于公价成交。我确信百达翡丽在增产时会留出很大安全边际，因为一旦二级市场价格接近公价，就意味着逼近价格坍塌——而由于人们如今把这些表当作投资购买，这将产生与资产泡沫破裂同样灾难性的级联效应。这不仅“像”资产泡沫破裂，它就会“是”资产泡沫的破裂。顶级制表商如今从事的业务：是精心管理一个可持续的资产泡沫。[16]
                <br/><br/>
                这是我所谓“遮秃效应”（comb-over effect）的一个例子：一连串单独看来都很小的改变，会把你从“有点不对劲”带到“离谱得吓人”。我相信百达翡丽并非一口气设计出整套机制；我相信它是渐进演化的。但看看我们最终落到了多么奇怪的地方：黄金时代买百达翡丽的方法是去珠宝商那里付钱；如今百达翡丽在“执法”监督买家以维持资产泡沫。
                <br/><br/>
                在我看来，品牌时代最惊人的，是它的彻底怪异：看似独立、甚至拥有自营门店的僵尸表牌，都归少数控股公司所有；巨大且形状尴尬的手表，把 500 年来让手表更小的进步倒转；一种需要公司在二级市场回购自家手表以抓“违规客户”（rogue customers）的商业模式；以及“违规客户”这个概念本身。一切都如此怪异。之所以怪异，是因为没有功能可供形式追随（no function for form to follow）。
                <br/><br/>
                直到黄金时代结束之前，机械表是必需品：你需要它来知道时间。这一约束给了手表和制表业一种有意义的形状。黄金时代也确实有些造型奇特的手表，并非全都极简优雅。但当黄金时代制表商做一只奇特的表时，他们知道自己在做什么，甚至像是在刻意练习，以免陷入一成不变的套路。
                <br/><br/>
                但这不是品牌时代的手表看起来怪异的原因。它们奇怪，是因为它们没有实用功能。它们的功能是表达品牌，这当然也是一种约束，但不是那种能产出好东西的“干净约束”（clean kind of constraint）。品牌施加的约束最终依赖于人类心理中一些最糟糕的特征。所以当一个世界只由品牌定义时，它会是一个怪异而糟糕的世界。


                说到这里有点阴暗。我们能从废墟里提炼出什么令人振奋的教训吗？
                <br/><br/>
                一个显而易见的教训就是远离品牌。也许不仅要避免购买品牌，也要避免贩卖品牌。你当然可能因此赚钱 —— 尽管我猜这比看起来更难做到 —— 但“按压”人们的品牌“按钮”并不是一个值得投入精力的好问题；而没有好问题，很难做出好工作。
                <br/><br/>
                更微妙的教训是：所有领域都有其自然节律，个人很难逆之而行。领域有黄金时代，也有不那么黄金的时代；在一个上升中的领域里做出好工作，概率更大。
                <br/><br/>
                当然，当黄金时代正在发生时，人们并不会叫它黄金时代。“黄金时代”是事后才使用的词。这并不意味着黄金时代不真实，而是意味着参与者当时把它当作理所当然。他们并不知道自己拥有过的有多好。通常把好运当作理所当然是错误的，但在这里不是。身处黄金时代的感觉，不过是：聪明人正努力解决有趣的问题，并且取得成果。若为追求更多而过度优化，反倒是过拟合。
                <br/><br/>
                事实上有一个原则，既能把你从品牌这类事情中救出来，也会自动把你带到黄金时代。追随问题（Follow the problems）。
                <br/><br/>
                找到黄金时代的方法不是去寻找黄金时代。找到它们的方法 —— 几乎所有历史参与者实际采用的方法 —— 就是追随有趣的问题。如果你聪明、有野心、并且对自己诚实，没有什么比你对问题的品味更好的向导。去有趣问题所在之处，你大概率会发现其他聪明而有野心的人也在那里。后来，人们会回头把你们共同做的事称为黄金时代。
                <br/><br/><br/><br/>

                <b>注释 Notes</b>
                <br/><br/>
                [1] 布雷顿森林体系并非直接固定货币之间的汇率，而是把各货币相对黄金的比价固定。显然这也就间接固定了彼此之间的汇率。
                <br/><br/>
                [2] Golden Ellipse 并不完全是圆角矩形，因为边并非完全平直。它的形状类似皮特·海因（Piet Hein）在 20 世纪 60 年代初推广的“超椭圆”（superellipse），名称也可能由此而来。但从数学上说它并不是真正的超椭圆。我猜百达翡丽的设计师只是用法式曲线板反复试到满意为止。公平地说，这确实是个好形状。
                <br/><br/>
                [3] 颇具讽刺的是，犯这个错的偏偏是百达翡丽，因为 Adrien Philippe 正是现代表冠的发明者。不过他们想必意识到了问题，因为后来的 Ellipse 表冠反而显得过于突出。
                <br/><br/>
                [4] 精品艺术里“设计空间 / 从业者”的高比例，再加上“归属鉴定”（attribution）的现实重要性，让人误以为“画出很达·芬奇的风格”就是达·芬奇之所以伟大的原因。策展人、艺术史学者与艺术交易商面临的最危险问题 —— 答错后果最严重的问题 —— 就是作品归属。因此他们不可避免地花大量时间谈论区分艺术家风格的特征。但那不是艺术家之所以伟大的原因。一张达·芬奇素描中女人脸颊的线条之所以好，是因为它作为“脸颊的线条”本身就好看，而不是因为它不像其他画家的线条。 绘画的高声望进一步给相邻领域的糟糕设计提供了遮羞布：某个品牌为了区分产品而做出丑陋设计时，可以说“像所有伟大的艺术作品一样，我们有独特风格”，人们也会买账。
                <br/><br/>
                [5] 百达翡丽在美国 1970 年的一则广告曾著名地把一只配金表链的 Patek 3548 称为“1700 美元的信托基金”。这真是好的投资建议吗？在最理想情况下，如今经销商可能会以 2 万美元收一只未佩戴、盒证齐全的，约合 4.5% 的回报率，并非完全糟糕。但同期标普 500 的平均回报率据说更接近 10%（在缴税后把分红再投资）；即便只是买一坨未被做成手表的黄金，平均回报也会超过 9%。所以不意外，这广告并不是很好的投资建议。
                <br/><br/>
                [6] 90 年代负责百达翡丽美国市场的 Tania Edwards 说，Bittel 曾在纸上“直接画出”3919 的设计。我觉得这有点奇怪，因为 3919 看起来就是在既有的 3520 上加了小秒盘（6 点位上方的小表盘）。既然几乎一样，为什么不直接指着现有款说“这个，加小秒盘”？不过这个故事至少显示：百达翡丽内部对广告公司在 3919 设计中所扮演角色的认知程度。
                <br/><br/>
                [7] 如果要精确给机械表的转折点定年，我会说是 1986。瑞士表销量在 1985 年回升，但营收没有，这意味着增长来自廉价石英 Swatch 的爆发；实际上若营收持平却卖了那么多 Swatch，机械表销售必然在下降。而 1986 年营收即使销量仅小幅增长却显著上扬，意味着昂贵机械表销售相应增加。
                <br/><br/>
                [8] 当然，有些人喜欢机械表还有另一个原因：对旧技术本身感兴趣。如果你真心喜欢机械表，这里有个好消息：你不必在手腕上戴广告牌，也不必花很多钱。买黄金时代的表就好：它们依然走时不错，更美，而且价格只是新表的一小部分。 买黄金时代手表的关键是找到靠谱的商家；识别方式是看对方告诉你关于手表的信息有多少。差商家会堆砌品牌声望与“流畅线条”的空话；好商家会告诉你型号与机芯编号，提供大量照片（包括开底盖），给出尺寸，披露所有损伤与修复，并准确说明走时误差。好商家往往自己也是表迷，会乐于提供这类信息。 （现在仍有少数独立制表师在真诚努力做出好机械表，但他们的尝试也表明：当大势不在你这边时，做好工作有多难。）
                <br/><br/>
                [9] 有趣的是，3919 是手动上链可能反而有利。如果一只表连续运行很久，每天 5 秒会累积：三个月后会快 7 分钟。但手动上链的表你偶尔会忘记上链而停走；再上链时你会重新对时——平均而言会被对到比真实时间慢约 30 秒的位置。所以如果你大约每两周忘记给 3919 上一次链，它很少会显示明显错误的时间。
                <br/><br/>
                [10] 还有一个品牌仍在等待被“重新充气复活”：Universal Genève（宇宙表）。它是黄金时代的大玩家之一，但自 1977 年起基本只是一个在收购者之间辗转的品牌名。据说它计划在今年晚些时候“复活”，届时想必会讲很多关于悠久制表传统的故事。
                <br/><br/>
                [11] 更精确地说，是“尺寸与准确度的比值高”意味着便宜。更大的机芯更容易做准；但在同等准确度下，尺寸更大的通常更便宜。
                <br/><br/>
                [12] 这些设计曾经确实是形式追随功能：它们最初是潜水表。但如今早已不再为此目的所需。当代潜水设备（现在叫潜水电脑）是数字的，且提供远不止时间的信息。
                <br/><br/>
                [13] 劳力士在 50 年代平均每年获授 16.6 项专利，但 60 年代只有 1.7 项。 Pierre-Yves Donzé，《地位象征的制造：劳力士商业史》（The Making of a Status Symbol: A Business History of Rolex），曼彻斯特大学出版社，2025。
                <br/><br/>
                [14] 劳力士与 SUV 还共享一种更具体的特质：一种“可企及的男子气概”。劳力士广告公司 J. Walter Thompson 在 1967 年的一份内部报告解释了他们要传达的概念：“因为劳力士被设计用于任何场景——无论多么粗砺、危险、英勇或崇高——它暗示戴表的男人在潜力上是一位英雄。” 载于 Donzé，同上。
                <br/><br/>
                [15] 这种商业模式只有在购买决策主要由品牌驱动时才成立。在正常市场中，如果某厂家限制产量，消费者会转向其他能提供同等性能的竞争者。只有当消费者追求的是“某个品牌”而不是“某个性能水平”时，你才能通过限制供给来操纵他们。
                <br/><br/>
                [16] 看到泡沫时人们第一个问题当然是：它会破吗？普通泡沫最终会破，是因为投机者过度乐观；但在这里，百达翡丽 CEO 控制着“货币供给”（供给量），可以采取措施给过热市场降温。所以他们这个特定泡沫大概只有两种破裂路径：继任者能力不足，或“佩戴机械表”的习俗整体消失。后者更危险。人们不会在手腕上戴三样东西；只要出现两种流行的腕上设备，下一代年轻富人就可能把机械表视为“老男人的东西”。很难想象奢侈腕表品牌如何在那种情况下存活。
                <br/><br/><br/><br/>

                感谢 Sam Altman、Bill Clerico、Daniel Gackle、Luis Garcia、Goldammer 的朋友们、Jessica Livingston、Ben
                Miller、Robert Morris、John Reardon、D’Arcy Rice、Alex Tabarrok 和 Garry Tan 阅读草稿并提出意见。


            </p>

            <br/>

            <h6 className="App-essay-title">The Brand Age</h6>
            <p className="App-essay-article">
                <br/>
                <b>Mar 2026</b>
                <br/><br/>

            </p>
        </div>)
}
